import { axiosJsonp, request } from '../../index';

const appServices = {
  // 获取平台数据
  getPlatformData(data?: Record<string, any>): any {
    return request.post('/v1', data, {
      headers: {
        cmdId: 371130,
        headerType: 1,
        apiName: 'getPlatformData',
        tid: '',
      },
    });
  },
  async loadJsonp(url: string, callback: (result: 'success' | 'error') => void) {
    try {
      const res = await axiosJsonp(url);
      console.log(res, 'getPlatformData366496');
      if (res.status === 200 || res.status === 417 || res.status === 416) {
        callback('success');
      } else {
        callback('error');
      }
    } catch (e) {
      callback('error');
    }
  },
  // measureDomainLoadTime(domain) {
  //   return new Promise((resolve, reject) => {
  //       const img = new Image();
  //       const startTime = performance.now();
  //      console.log(startTime)
  //       img.onload = function() {
  //           const endTime = performance.now();
  //           const loadTime = endTime - startTime;
  //           resolve(loadTime);
  //       };

  //       img.onerror = function() {
  //           reject(new Error('Failed to load image'));
  //       };
  //       if(domain.indexOf('http')!=-1){
  //         img.src = `${domain}/favicon.ico`;
  //       }else{
  //         img.src = `http://${domain}/favicon.ico`;
  //       }

  //       console.log(img,'measureDomainLoadTime')
  //   });
  // }
  measureDomainLoadTime(domain) {
    // 改用 fetch() 测试可达性
    return new Promise((resolve, reject) => {
      const startTime = performance.now();
      fetch(domain, { method: 'HEAD', mode: 'no-cors' }) // HEAD请求不用获取页面内容
        .then(() => {
          const endTime = performance.now();
          resolve(endTime - startTime);
        })
        .catch(err => {
          reject(new Error('测速失败'));
        });
    });
  },
};

export default appServices;
